<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 300 300"><g transform="matrix(2.970823 0 0 2.9708227 -267.57133 690.03506)" style="fill-rule:evenodd"><path d="m 140.55752,-232.2707 c 27.8855,0 50.491,22.60562 50.491,50.49112 0,27.8855 -22.6055,50.49101 -50.491,50.49101 -27.8855,0 -50.49112,-22.6055 -50.49112,-50.49101 0,-27.88549 22.60562,-50.49112 50.49112,-50.49112" style="fill:#f5f5f5"/><g transform="matrix(1.25 0 0 -1.25 -108.47035 1180.7538)" style="stroke-miterlimit:2.613126;stroke:#564a4c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.4998"><path d="m 197.8977,1075.6128 -14.3034,16.1578 29.2252,3.5759 -14.9218,-19.7337 z" style="fill:#cec7c4"/><g style="fill:#fff"><path d="m 201.2692,1093.9331 -3.3715,-18.3203 16.9526,7.5932 -13.5811,10.7271 z"/><path d="m 201.2692,1093.9331 -14.1432,10.5075 4.3657,-11.7037 9.7775,1.1962 z"/></g></g></g></svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 300
      },
      height: {
        type: [Number, String],
        default: 300
      }
    }
  }
</script>